import {memo} from 'react'
import {format} from 'date-fns'
import {Text} from '@/components/ui/text/Text'
import {StyledMessageWrapper, StyledMessageItem, StyledUrgentTagIcon, StyledMessageText} from './style.ts'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {Avatar} from '@/components/ui/avatar/Avatar'
import {ConversationMessage} from '../../types.ts'
import {useAuthStore} from '@/features/auth/store/store.ts'

interface MessageBubbleProps {
    message: ConversationMessage
}

const MessageBubbleComponent = ({message}: MessageBubbleProps) => {
    const currentUser = useAuthStore(state => state.user)
    const isOwnMessage = message.senderId === currentUser?.id
    const {sender, createdAt, isUrgent, message: messageText} = message
    const senderName = `${sender.firstName} ${sender.lastName}`

    return (
        <StyledMessageWrapper $isOwnMessage={isOwnMessage} fullWidth>
            <Avatar size="xs" name={senderName} imageUrl={sender.avatarUrl || undefined} />
            <StyledMessageItem $isOwnMessage={isOwnMessage}>
                <Flexbox direction="row" gap={1} align="center" justify="space-between">
                    <Text size="textXs" palette="neutral" shade="800" weight="600">
                        {senderName}
                    </Text>
                    <Flexbox direction="row" gap={1} align="center">
                        <Text size="textXs" palette="neutral" shade="500">
                            {format(new Date(createdAt), 'HH:mm')}
                        </Text>
                        {isUrgent && <StyledUrgentTagIcon size={16} />}
                    </Flexbox>
                </Flexbox>
                <StyledMessageText size="textSm" palette="neutral" shade="900">
                    {messageText}
                </StyledMessageText>
            </StyledMessageItem>
        </StyledMessageWrapper>
    )
}

export const MessageBubble = memo(MessageBubbleComponent)
